module.exports = __webpack_public_path__ + "img/winti-fit-logo.0dfc74a6.png";